import Icon from '../../components/Icon.vue'

Icon.register({"brands/docker":{"width":640,"height":512,"paths":[{"d":"M349.9 236.3H283.8V176.9H349.9V236.3zM349.9 32H283.8V92.7H349.9V32zM428.1 176.8H362V236.2H428.1V176.8zM271.8 104.7H205.7V164.8H271.8V104.7zM349.9 104.7H283.8V164.8H349.9V104.7zM626.7 204.7C612.3 195 579.1 191.5 553.6 196.3 550.3 172.3 536.9 151.4 512.5 132.6L498.5 123.3 489.2 137.3C470.8 165.1 465.8 210.9 485.5 241.1 476.8 245.8 459.7 252.2 437.1 251.8H2.4C-6.3 302.6 8.2 368.6 46.4 413.9 83.5 457.8 139.1 480.1 211.8 480.1 369.2 480.1 485.7 407.6 540.2 275.9 561.6 276.3 607.8 276 631.5 230.7 633 228.2 638.1 217.5 640 213.6L626.7 204.7zM115.6 176.8H49.6V236.2H115.7V176.8zM193.7 176.8H127.6V236.2H193.7V176.8zM271.8 176.8H205.7V236.2H271.8V176.8zM193.7 104.7H127.6V164.8H193.7V104.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/docker.js
// module id = /PDA
// module chunks = 0